/**
 * Pure-string check: does the contract type indicate an "Option" contract
 * (rental: 'OP', or option-with-years 'OP1'..'OP99')?
 *
 * Promoted to shared utils in 9o.6.a (was named-exported from
 * components/modals/DropDesignationModal.js). Used by both desktop and mobile
 * DropDesignation modals. Pure function, no UI coupling.
 */
export const isOptionContract = (ct) => ct === 'OP' || (ct?.startsWith('OP') && /^\d+$/.test(ct.slice(2)));

/**
 * Shared contract display utilities.
 *
 * formatContractDisplay(contractType, contractYears)
 *   - OP contracts: show type directly ("OP", "OP1", "OP2")
 *   - Original contracts: "1 yr", "2 yr", "3 yr"
 *   - No data: "\u2014"
 */

export const formatContractDisplay = (contractType, contractYears) => {
  if (contractType && contractType.startsWith('OP')) {
    return contractType;
  }
  if (contractType === '1' || contractType === '2' || contractType === '3' || contractType === '4') {
    return `${contractType} yr`;
  }
  if (contractYears) {
    return `${contractYears} yr`;
  }
  return '\u2014';
};

/**
 * Return the user-visible total salary cap for a league's salary_settings,
 * dual-cap-aware. When use_dual_cap is true, total = draft_cap (default
 * 600) + season_cap (default 200). When use_dual_cap is false/absent
 * (legacy single-cap mode), returns salary_cap with canonical 800
 * fallback. Defaults match backend Pydantic schema at
 * routers/leagues/lifecycle.py:128-131.
 *
 * Replaces the legacy `salary_cap || 260` antipattern that hid the
 * dual-cap migration from display sites. See 8m.5c.salary forensics.
 */
export const getTotalSalaryCap = (salarySettings) => {
  if (salarySettings?.use_dual_cap) {
    return (salarySettings?.draft_cap ?? 600) + (salarySettings?.season_cap ?? 200);
  }
  return salarySettings?.salary_cap ?? 800;
};
